<template>
  <div>
    <div class="row">
      <div class="container my_new_container">
        <!-- Dashboard Headline -->
        <div class="dashboard-headline">
          <h1>User Badges</h1>
          <!-- Breadcrumbs -->
          <nav id="breadcrumbs" class="dark">
            <ul>
              <li><a href="#">Home</a></li>
              <li>User Badges</li>
            </ul>
          </nav>
        </div>
        <b-tabs class="my_tab_job tab_header_action_th">
            <b-tab :title="'User Badges'" @click="changeTab('userbadges')">
                <div class="container new_cnt_pdng my_new_container">
                    <div class="row">
                        <div
                        class="big_screen_calendr_font search_common_margin_bottom_28 mobile_tab_max_width_flex select-service-box date-picker-field clearfix col-xl-6 col-md-6 calender_z_index_9 calender_in_mobile new_calender_section"
                        >
                            <!-- <div class="search-box custom_search_admin desktop_margin_top_zero"> -->
                            <!-- <b-input-group> -->
                            <!-- <br/> -->
                            <div>
                                <label class="new_style_label required_sign required desktop_margin_bottom_zero"
                                >Badge</label
                                >
                                <b-form-group
                                    id="input-group-8"
                                    class="desktop_margin_bottom_zero multiselct_z_index"
                                >
                                    <multiselect
                                        id="ajax"
                                        :key="badges.length"
                                        v-model="badge"
                                        :custom-label="customLabel"
                                        tag-placeholder="Search Badges"
                                        placeholder="Badge"
                                        :options="badges"
                                        label="name"
                                        track-by="id"
                                        @input="changeTab('userbadges')"
                                        :multiple="true"
                                        :searchable="true"
                                        :clear-on-select="true"
                                        :close-on-select="true"
                                        :allow-empty="true"
                                        deselect-label="Can't remove this value"
                                        open-direction="bottom"
                                        class="job_list_multi_select model_multi_select admin_multi_select new_multiselct_height common_black_multiselect_border"
                                    >
                                        <template #option="{ option }">
                                            <div class="d-flex align-items-center">
                                                <img
                                                :src="option.badge_image"
                                                alt="badge"
                                                width="30"
                                                height="30"
                                                class="mr-2 rounded"
                                                />
                                                <span>{{ option.name }}</span>
                                            </div>
                                        </template>
                                        <span slot="noResult">No Badge Found.</span>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!-- </b-input-group> -->
                            <!-- </div> -->
                        </div>
                        <div
                        class="col-xl-6 col-md-6 mobile_tab_max_width_flex search_common_margin_bottom_28"
                        >
                            <div
                                class="sidebar-widget job_list_btn_search mobile_space_between penalty_btn desktop_margin_bottom_zero food_btn"
                            >
                                <!-- <b-button @click="changeTabOverall()" class="button ripple-effect search_btn_all filter_btn_widht_120 desktop_margin_left_zero desktop_margin_right_zero" style="width: 120px;">Search</b-button> -->
                                <b-button
                                    @click="resetFilter()"
                                    class="ml-3 new_reset_text  mobile_tab_padding_right_zero mobile_tab_padding_left_zero mobile_tab_padding_top_zero mobile_tab_padding_bottom_zero  new_black_reset_filter common_font_size_14 common_reset_btn_filter_transactions button ripple-effect search_all_red_btn filter_btn_widht_120 desktop_margin_right_zero m-0"
                                    style="background-color: red; margin-top: 20px;">
                                    <span class="mobile_reset">Reset filters</span></b-button
                                >
                                <b-button
                                    v-if="show('export')"
                                    class="button ripple-effect add_btn_admin_e desktop_margin_right_zero"
                                    @click="exportUserBadges()"
                                    style="margin-left: 20px"
                                >Export</b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Page Content
            ================================================== -->

                <div class="row">
                    <div class="container my_new_container show_filter_arrow">
                        <b-table
                            ref="datatable"
                            show-empty
                            striped
                            hover
                            responsive
                            :items="getUserBadges"
                            :fields="fields"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            class="desktop_margin_top_zero new_box_tbl_mrgn mobile_min_width_1000 nine_grid_tbl_new"
                        >
                            <template #cell(full_name)="items">
                                <div class="user_name_div">
                                    <b-link
                                        :to="
                                        show('view profile')
                                            ? {
                                                name: 'jobseeker-dp-profile-view',
                                                params: { id: encrypt(items.item.user_id) },
                                            }
                                            : null
                                        "
                                        target="_blank"
                                        style="color: #4c8bf5"
                                    >
                                        {{ items.item.full_name | capitalize }}
                                    </b-link>
                                </div>
                            </template>
                            <template #cell(nric)="items">
                                {{ items.item.nric }}
                            </template>
                            <template #cell(mobile_number)="items">
                                <b-link
                                    :href="'https://wa.me/+65' + items.item.mobile_number"
                                    target="_blank"
                                    style="color: #4c8bf5"
                                >
                                    {{ items.item.country_code }}-{{ items.item.mobile_number }}
                                </b-link>
                            </template>
                            <template #cell(badge_name)="items">
                                {{ items.item.badge_name | capitalize }}
                            </template>
                            <template #cell(badge_image)="items">
                                <viewer>
                                    <img :src=" items.item.badge_image != null
                                            ? items.item.badge_image
                                            : webUrl + 'assets/images/logo.png'
                                        "
                                        height="100px" width="100px"  alt="logo"/>
                                </viewer>
                            </template>
                        </b-table>

                        <nav class="pagination-box custom_pagination_border_radius">
                            <div class="page-row-box d-inline-block">
                                <b-form-group id="input-group-4">
                                <span class="d-inline-block">Rows per page</span>
                                <span class="d-inline-block"
                                    ><b-form-select v-model="form.rowsPerPage" @change="getUserBadges">
                                        <option>25</option>
                                        <option>50</option>
                                        <option>75</option>
                                        <option>100</option>
                                    </b-form-select></span
                                >
                                </b-form-group>
                            </div>
                            <div class="total-page-count d-inline-block">
                                <ul>
                                <li>
                                    <span v-if="totalRows != 0">{{ from }} - {{ to }} of {{ totalRows }}</span>
                                </li>
                                </ul>
                            </div>
                            <b-pagination
                                :total-rows="totalRows"
                                :per-page="perPage"
                                v-model="currentPage"
                                prev-text=""
                                next-text=""
                                hide-goto-end-buttons
                            />
                        </nav>
                    </div>
                </div>
            </b-tab>  
        </b-tabs>
      </div>
    </div>
    <!-- Spacer -->
    <!-- <div class="margin-top-70"></div> -->
    <!-- Spacer / End-->
    <!-- Row / End -->
  </div>
</template>   

<script>
import { POST_API } from "../../../../store/actions.type";
import Multiselect from "vue-multiselect";
import permission from "../../../../../../server/permission.js";

export default {
  data() {
        return {
            fields: [
                { key: "full_name", label: "Name", sortable: true },
                { key: "nric", label: "NRIC", sortable: true, thStyle: { width: "13%" } },
                { key: "mobile_number", label: "Mobile Number", sortable: true },
                { key: "badge_name", label: "Badge Name", sortable: true },
                { key: "badge_image", label: "Badge Image", sortable: true },
            ],
            pager: {},
            pageOfItems: [],
            badges: [],
            items: [],
            badge: [],
            totalRows: 0,
            from: "",
            to: "",
            currentPage: 1,
            perPage: 25,
            sortBy: null,
            sortDirection: "desc",
            sortDesc: true,
            filter: "",
            sortDesc: true,
            webUrl: process.env.VUE_APP_URL,
            currentTab: "userbadges",
            form: {
                rowsPerPage: 25,
            },
            total_uploaded: 0,
            webServerUrl: process.env.VUE_APP_SERVER_URL,
        };
    },
    filters: {
        capitalize: function (value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        removeUnderscore: function (value) {
            if (!value) return "";
            var i,
                frags = value.split("_");
            for (i = 0; i < frags.length; i++) {
                frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
            }
            return frags.join(" ");
        },
    },
    components: {
        Multiselect,
    },
    methods: {
        showSuccessAlert(message) {
            this.$swal({
                position: "center",
                icon: "success",
                iconColor: "#4c8bf5",
                title: message,
                showConfirmButton: false,
                timer: 1500,
            }).then((result) => {
                this.$refs.datatable.refresh();
            });
        },
        showAlert() {
            this.$swal({
                position: "center",
                icon: "error",
                title: this.error_message,
                showConfirmButton: false,
                timer: 1500,
            });
        },
        customLabel({ name }) {
            return `${name}`;
        },
        changeTab(currentTab) {
            this.currentTab = currentTab;
            this.$refs.datatable.refresh();
        },
        resetFilter() {
            if (this.currentTab == "userbadges") {
                this.badge = [];
                this.filter = "";
                this.$refs.datatable.refresh();
            }
        },
        getBadges() {
            this.$store
                .dispatch(POST_API, {
                    data: {},
                    api: "/api/badge-list",
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;

                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: this.error_message,
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    } else {
                        this.badges = this.$store.getters.getResults.data;
                    }
                });
        },
        getUserBadges() {
            return this.$store
                .dispatch(POST_API, {
                    data: {
                        badge_ids: this.badge.map(b => b.id),
                        page: this.currentPage,
                        rowsPerPage: this.form.rowsPerPage,            
                        sortBy: this.sortBy ? this.sortBy : "",
                        sortDirection: this.sortDesc ? "desc" : "asc",
                    },
                    api: "/api/user-badges-list",
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                        return [];
                    } else {
                        this.items = this.$store.getters.getResults.data;
                        this.totalRows = this.$store.getters.getResults.pager.totalItems;
                        this.perPage = this.$store.getters.getResults.pager.pageSize;
                        this.from = this.$store.getters.getResults.pager.from;
                        this.to = this.$store.getters.getResults.pager.to;
                        return this.items;
                    }
                });
        },
        exportUserBadges() {
            const base_url_v2 = this.webServerUrl;

            // Convert badge ID array into query parameters like: badge_ids=1&badge_ids=2
            const badgeIds = this.badge.map(b => `badge_ids=${encodeURIComponent(b.id)}`).join('&');
            const sortBy = this.sortBy ? `sortBy=${encodeURIComponent(this.sortBy)}` : '';
            const sortDirection = this.sortDesc ? 'desc' : 'asc';

            const queryParts = [
                badgeIds,
                sortBy,
                `sortDirection=${encodeURIComponent(sortDirection)}`
            ].filter(Boolean).join('&'); // removes any empty parts

            const export_url = `/api/export-user-badges-list?${queryParts}`;

            window.open(base_url_v2 + export_url, "_blank");
        },
        permissionStaff() {
            if (this.$store.getters.getCurrentUserPermission) {
                if (
                this.$store.getters.getCurrentUserPermission.data.length > 0 &&
                this.$store.getters.currentUser.user_type_id == 2
                ) {
                var menu = this.$store.getters.getCurrentUserPermission.data;
                this.actions = permission.getPermissionStaff(menu, "User Badges");
                this.actionsFreelancer = permission.getPermissionStaff(menu, "Jobseekers");
                }
            }
        },
        show(action) {
            if (this.$store.getters.currentUser.user_type_id == 2) {
                return this.actions.indexOf(action) >= 0 ? true : false;
            } else {
                return true;
            }
        },
    },
    mounted() {
        $(".show_filter_arrow .table thead th div").contents().unwrap();
        $(".dashboard-content-container .simplebar-scroll-content").animate(
            {
                scrollTop: 0,
            },
            "fast"
        );
        this.user_id =
            this.$store.getters.currentUser != null ? this.$store.getters.currentUser.id : "";
        this.permissionStaff();
        this.getBadges();
    },
};
</script>